export async function ensureGsap() {
  const [gsapModule, scrollTriggerModule] = await Promise.all([
    import("gsap"),
    import("gsap/ScrollTrigger"),
  ]);

  const gsap = gsapModule.default;
  const ScrollTrigger =
    scrollTriggerModule.default ||
    scrollTriggerModule.ScrollTrigger ||
    scrollTriggerModule;
  if (gsap && ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  return { gsap, ScrollTrigger };
}

/**
 * Same as ensureGsap() but also lazy-loads and registers ScrollToPlugin, for
 * components that call gsap.to(window, { scrollTo }). Keeps all GSAP code out of
 * the initial bundle.
 */
export async function ensureGsapWithScrollTo() {
  const [gsapModule, scrollTriggerModule, scrollToModule] = await Promise.all([
    import("gsap"),
    import("gsap/ScrollTrigger"),
    import("gsap/ScrollToPlugin"),
  ]);

  const gsap = gsapModule.default;
  const ScrollTrigger =
    scrollTriggerModule.default ||
    scrollTriggerModule.ScrollTrigger ||
    scrollTriggerModule;
  const ScrollToPlugin =
    scrollToModule.default ||
    (scrollToModule as { ScrollToPlugin?: unknown }).ScrollToPlugin ||
    scrollToModule;

  if (gsap && ScrollTrigger && ScrollToPlugin) {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  }

  return { gsap, ScrollTrigger, ScrollToPlugin };
}
